<div [ngClass]="{ 'disabled-project': !project.isactive }" class="card p-2 mb-3 bg-secondary project-controller">
  <div class="row">
    <div (click)="clickWork.emit(project)" class="col- pl-3">
      <app-customerlogo [customerlistmode]="true" [customerId]="project.customer"
        [enableChange]="false"></app-customerlogo>
    </div>

    <div (click)="clickWork.emit(project)" class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-7">
      <h6 appHighlight [searchedWord]="filterTxt" [content]="project.title" [classToApply]="'font-weight-bold'"
        [setTitle]="'true'" class="lh-35 align-middle mb-0 font-weight-light cursor-default text-truncate">
      </h6>
    </div>

    <!---<div class="col- d-block d-sm-none">

    Mobile VERSION
      <span *ngIf="project.overduedays >= 3"
        class="material-icons indicator-icon-red cursor-default pr-1 d-block d-sm-none"
        matTooltip="{{ project.title }} {{ 'projectlist.redindicatortool' | trans }}" matTooltipPosition="above"
        style="position: inherit!important;" matTooltipShowDelay="500">whatshot</span>

      <span *ngIf="project.overduedays > 0 && project.overduedays < 3"
        class="material-icons indicator-icon-yellow cursor-default pr-1 d-block d-sm-none"
        matTooltip="{{ project.title }} {{ 'projectlist.yellowindicatortool' | trans }}" matTooltipPosition="above"
        style="position: inherit!important;" matTooltipShowDelay="500">error</span>
    </div>-->
    <div (click)="clickWork.emit(project)" *ngIf="!customerportal && !gaugeExpanded"
      class="col-xl-3 col-lg-3 col-md-4 col-sm-4 d-none d-md-block">
      <app-customername class="align-middle d-inline-block lh-35" [pretext]="true"
        [customerId]="project.customer"></app-customername>
    </div>

    <div (click)="clickWork.emit(project)" *ngIf="!gaugeExpanded" class="col-xl-2 col-lg-2 d-none d-lg-block">
      <p class="align-middle lh-35 mb-0 cursor-default text-truncate">
        {{ project.start_date | date: (showStartYear ? 'yyyy MMM dd' : 'MMM dd') }} - {{ project.end_date | date:
        (showEndYear ? 'yyyy MMM dd' : 'MMM dd') }}
        <!---- {{ project.start_date | date: 'MMM-dd' }} - {{ project.end_date | date: 'MMM-dd' }}--->
      </p>
    </div>

    <!----<div #personnameele (click)="clickWork.emit(project)" *ngIf="!gaugeExpanded"
      class="col-2 d-none d-lg-block box text-truncate">
      <p class="lh-35 mb-0 cursor-default">
        {{ 'projectlist.workload' | trans }} - {{ project.workload_fte }}
        <app-personname *ngIf="pnewidth" class="align-middle d-inline-block lh-35" [viewtypeportal]="true"
          [widthpne]="pnewidth" [enableChange]="false" [personId]="project.creator">
        </app-personname>
      </p>
      <p *ngIf="timeregEnabled && timeCounterLabel() as counter" class="mb-0 cursor-default f-12"
        [matTooltip]="timeCounterTooltip()" matTooltipPosition="above" matTooltipShowDelay="300">
        {{ counter }}
      </p>
    </div>--->

    <div class="col position-relative">
      <!--- Engagement indicators --->
      <app-engagement-gauge [projectId]="project.projectId" [engagementData]="project.engagement"
        [customerId]="customerId" (expandedChange)="onGaugeExpandedChange($event)">
      </app-engagement-gauge>
      <!-- Dropdown Toggle (Mobile) -->
      <button *ngIf="!customerportal && orgedit" style="position: absolute; top: 0px; right: 10px;"
        class="btn-empty border-0 d-block d-sm-none" type="button" data-toggle="collapse"
        [attr.data-target]="'#mobiledrop'+project.projectId">
        <span class="material-icons">more_vert</span>
      </button>

      <!-- Red & Yellow Indicators -->
      <!--- DESKTOP VERSION
      <span *ngIf="project.overduedays >= 3"
        class="material-icons indicator-icon-red cursor-default pr-1 d-none d-sm-block"
        matTooltip="{{ project.title }} {{ 'projectlist.redindicatortool' | trans }}" matTooltipPosition="above"
        matTooltipShowDelay="500">whatshot</span>
      <span *ngIf="project.overduedays > 0 && project.overduedays < 3"
        class="material-icons indicator-icon-yellow cursor-default pr-1 d-none d-sm-block"
        matTooltip="{{ project.title }} {{ 'projectlist.yellowindicatortool' | trans }}" matTooltipPosition="above"
        matTooltipShowDelay="500">error</span>-->


      <!-- Dropdown Menu (Desktop) -->
      <div *ngIf="!customerportal && orgedit" class="dropdown dropleft d-none d-sm-block pr-1"
        style="position: absolute; top: 0; right: 0;">
        <button class="btn-empty border-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <span class="material-icons cursor-pointer">more_vert</span>
        </button>
        <div class="dropdown-menu" style="border-radius: 5px;">
          <button class="dropdown-item" (click)="clikcDisable.emit(project)">
            <div class="d-inline lh-25 align-middle">
              {{ 'projectlist.visiblity' | trans }}
              <span class="material-icons float-right">visibility</span>
            </div>
          </button>
          <button *ngIf="project.isactive" (click)="clickAssign.emit(project)"
            class=" lh-25 align-middle dropdown-item">
            {{ 'projectlist.assign' | trans }}
            <span class="material-icons float-right">person_search</span>
          </button>
          <button *ngIf="project.isactive" (click)="clickTemplate.emit(project)" class="dropdown-item">
            <div class="d-inline-flex lh-25 align-middle">
              {{ 'projectlist.generatetemplate' | trans }}
              <span class="material-icons pl-2 float-right">post_add</span>
            </div>
          </button>
          <button *ngIf="project.isactive" data-toggle="modal" (click)="clickAutomation.emit(project)"
            data-target="#projectautomationmodal" class="dropdown-item lh-25 align-middle">
            {{ 'projectlist.automation' | trans }}
            <span class="material-icons float-right">settings</span>
          </button>
          <button *ngIf="project.isactive" (click)="clickEdit.emit(project)" class="dropdown-item lh-25 align-middle">
            {{ 'projectlist.edit' | trans }}
            <span class="material-icons float-right">create</span>
          </button>
          <button (click)="clickDelete.emit(project)" class="dropdown-item lh-25 align-middle">
            {{ 'projectlist.delete' | trans }}
            <span class="material-icons float-right">delete</span>
          </button>
        </div>
      </div>

      <!-- Dropdown Toggle (Mobile) 
      <button *ngIf="!customerportal && orgedit" class="btn-empty border-0 d-block d-sm-none" style="position: absolute; bottom:10px; right:0px;" type="button" data-toggle="collapse" [attr.data-target]="'#mobiledrop'+project.projectId">
        <span class="material-icons">more_vert</span>
      </button>-->

      <!-- Dropdown Menu (Mobile) -->
      <div class="collapse mt-2" [attr.id]="'mobiledrop'+project.projectId">
        <div class="show" style="border-radius: 5px;">
          <button class="dropdown-item" (click)="clikcDisable.emit(project)">
            <div class="d-inline lh-25 align-middle">
              {{ 'projectlist.visiblity' | trans }}
              <span class="material-icons float-right">visibility</span>
            </div>
          </button>
          <button *ngIf="project.isactive" (click)="clickAssign.emit(project)"
            class=" lh-25 align-middle dropdown-item">
            {{ 'projectlist.assign' | trans }}
            <span class="material-icons float-right">person_search</span>
          </button>
          <button *ngIf="project.isactive" (click)="clickTemplate.emit(project)" class="dropdown-item">
            <div class="d-inline-flex lh-25 align-middle">
              {{ 'projectlist.generatetemplate' | trans }}
              <span class="material-icons pl-2 float-right">post_add</span>
            </div>
          </button>
          <button *ngIf="project.isactive" data-toggle="modal" data-target="#projectautomationmodal"
            class=" lh-25 align-middle dropdown-item">
            {{ 'projectlist.automation' | trans }}
            <span class="material-icons float-right">person_search</span>
          </button>
          <button *ngIf="project.isactive" (click)="clickEdit.emit(project)" class="dropdown-item lh-25 align-middle">
            {{ 'projectlist.edit' | trans }}
            <span class="material-icons float-right">create</span>
          </button>
          <button (click)="clickDelete.emit(project)" class="dropdown-item lh-25 align-middle">
            {{ 'projectlist.delete' | trans }}
            <span class="material-icons float-right">delete</span>
          </button>
          <!-- Duplicate the same actions here for mobile if needed -->
        </div>
      </div>
    </div>
  </div>

  <div class="row progress-row pr-2 pl-2 ml-0 mr-0 mb-0 mt-2">
    <!-- Engagement Gauge for Vendor Portal 
    <div class="col-auto engagement-gauge-col" *ngIf="!customerportal && organizationId && customerId">
      <app-engagement-gauge 
        [engagementData]="project.customerEngagement"
        [customerId]="customerId">
      </app-engagement-gauge>[ngClass]="{'d-none d-md-block': gaugeExpanded}"
    </div>-->

    <div [ngClass]="{'col-3 col-md-5 col-lg-6': gaugeExpanded, 'col': !gaugeExpanded}">
      <app-projectprogress [projectId]="project.projectId" [fat]="false"></app-projectprogress>
    </div>
    <div [ngClass]="{'col-3': gaugeExpanded, 'd-none': !gaugeExpanded}" class="d-md-none"></div>
    <ng-container *ngIf="showFilter">
      <app-tagaddremove [viewmode]="true" [smalltype]="true" [entityId]="project.projectId"
        [tagtype]="'project'"></app-tagaddremove>
    </ng-container>
  </div>
</div>